import axios from "../utils/axios.instance";
import api from "../api";
import handleError from "./handle-error";

interface WalletRefundPayload{
  amountCents:number
  currency:string
  stripePaymentIntentId:string
}

export const walletRefund = async (payload:WalletRefundPayload) => {
  try {
    const { data } = await axios.post(api.walletRefund,payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};


export const stripeRefund = async (payload:WalletRefundPayload) => {
  try {
    const { data } = await axios.post(api.defaultRefund,payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const getWalletBalance = async () => {
  try {
    const { data } = await axios.get(api.walletBalance);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

interface WalletPurchasePayload{
  amountCents:number
  currency:string
  jobId:string
}

export const walletPurchase = async (payload:WalletPurchasePayload) => {
  try {
    const { data } = await axios.post(api.walletPurchase,payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};
